import actionTypes from '../actionTypes';
import { getSubscriptionExpiredStatus } from '../../utils';

const initialState = {
  status: null,
  clientToken: '',
  customer: null,
  subscription: null,
  transaction: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PAYMENT_CLIENT_TOKEN_REQUEST:
    case actionTypes.PAYMENT_CHECKOUT_REQUEST:
    case actionTypes.PAYMENT_CHECKOUT_ERROR:
    case actionTypes.PAYMENT_CHECKOUT_SUCCESS:
    case actionTypes.PAYMENT_GET_CUSTOMER_REQUEST:
    case actionTypes.PAYMENT_GET_SUBSCRIBE_REQUEST:
    case actionTypes.PAYMENT_SUBSCRIBE_REQUEST:
    case actionTypes.PAYMENT_TRANSACTION_REQUEST:
    case actionTypes.PAYMENT_CANCEL_SUBSCRIBE_REQUEST:
    case actionTypes.PAYMENT_CANCEL_SUBSCRIBE_ERROR:
      return { ...state, status: action.type };

    case actionTypes.PAYMENT_GET_CUSTOMER_ERROR:
      return { ...state, status: action.type, customer: null };

    case actionTypes.PAYMENT_GET_CUSTOMER_SUCCESS:
      return { ...state, status: action.type, customer: action.customer };

    case actionTypes.PAYMENT_GET_SUBSCRIBE_ERROR:
    case actionTypes.PAYMENT_SUBSCRIBE_ERROR:
    case actionTypes.PAYMENT_CANCEL_SUBSCRIBE_SUCCESS:
      return { ...state, status: action.type, subscription: null };

    case actionTypes.PAYMENT_GET_SUBSCRIBE_SUCCESS:
    case actionTypes.PAYMENT_SUBSCRIBE_SUCCESS: {
      let { subscription } = action;
      const subscriptionExpiresStatus = getSubscriptionExpiredStatus(
        action.subscription
      );
      subscription.subscriptionExpiresStatus = subscriptionExpiresStatus;
      return { ...state, status: action.type, subscription };
    }

    case actionTypes.PAYMENT_TRANSACTION_ERROR:
    case actionTypes.PAYMENT_TRANSACTION_SUCCESS:
      return { ...state, status: action.type, transaction: action.transaction };

    case actionTypes.PAYMENT_CLIENT_TOKEN_ERROR:
      return { ...state, status: action.type, clientToken: '' };

    case actionTypes.PAYMENT_CLIENT_TOKEN_SUCCESS:
      return { ...state, status: action.type, clientToken: action.clientToken };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/payment.js